import { Reducer } from 'redux';
import { IHoldRequestsListState } from 'interfaces/hold-requests-list-state';
import { HOLD_REQUESTS_LIST_ACTIONS } from './hold-requests-actions';
import { HOLD_REQUEST } from '../../actions';
import { IHoldRequestDetail } from 'interfaces/hold-request-detail';

const intialState: IHoldRequestsListState = {
  loading: false,
  holdRequests: [],
  error: '',
};

export const poItemHoldRequestsReducer: Reducer<IHoldRequestsListState> = (state = intialState, action: Action<string, any>) => {
  switch (action.type) {
    // Request
    case HOLD_REQUESTS_LIST_ACTIONS.REQUEST:
      return { ...state, loading: true };

    // Success
    case HOLD_REQUESTS_LIST_ACTIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        holdRequests: [...state.holdRequests, ...action.payload.items],
        totalCount: action.payload.total,
        currentPage: action.payload.offset
      };

    case HOLD_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD:
      let holdRequests = state.holdRequests.map(removeUnreadMapper(action.payload.holdRequestId));
      return { ...state, holdRequests };

    // Failure
    case HOLD_REQUESTS_LIST_ACTIONS.FAILURE:
      return { ...state, loading: false, error: 'Error getting hold requests.' };

    // Clear
    case HOLD_REQUESTS_LIST_ACTIONS.CLEAR:
      return { ...state, holdRequests: [] };

    case HOLD_REQUEST.RELEASE_SUCCESS:
      let holdRequestsToKeep = state.holdRequests.filter(holdRequest => holdRequest.id !== action.payload.holdRequestRequest.holdRequestId);
      return {
        ...state,
        holdRequests: holdRequestsToKeep
      };

    default:
      return state;
  }
};

const removeUnreadMapper = (holdRequestId: number) => (hr: IHoldRequestDetail) => {
  if (hr.id === holdRequestId) {
    return { ...hr, hasUnreadMessages: false };
  }
  return hr;
};
